var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCorrectField && _vm.showField)?_c('el-form-item',{staticClass:"filter-field",attrs:{"rules":_vm.rules,"prop":_vm.field.name}},[(_vm.field.type != 'bool')?_c('p',{staticClass:"filter-field__label"},[_vm._v(" "+_vm._s(_vm.field.label)+" ")]):_vm._e(),(_vm.field.type === 'phone')?_c('InputMasked',{attrs:{"field":{
      name: _vm.field.name,
      placeholder: '',
      type: _vm.field.type
    },"model":_vm.form[_vm.field.name] || '',"mask":[
      '#',
      '##',
      '###',
      '####',
      '#####',
      '######',
      '#######',
      '########',
      '#########',
      '##########',
      '###########',
      '############',
      '#############',
      '##############',
      '###############'
    ]},on:{"set-value":(name, val) => {
        _vm.setValue(_vm.field.name, val, _vm.field.type);
      }}}):(_vm.field.type === 'bool')?_c('div',{staticClass:"filter-field__items--switcher"},[_vm._v(" "+_vm._s(_vm.field.label)+" "),_c('Switcher',{attrs:{"model":Boolean(_vm.form[_vm.field.name]) || false},on:{"switch":val => {
          _vm.setValue(_vm.field.name, val);
        }}})],1):(_vm.field.type === 'enum' || _vm.field.type === 'dynamicMultienum')?_c('Dropdown',{ref:"dropdown",staticClass:"filter-form__filter",attrs:{"model":_vm.form[_vm.field.name] || '',"options":_vm.field.type === 'dynamicMultienum'
        ? _vm.paginOptions[_vm.field.name] || _vm.field.options
        : _vm.field.options,"filterable":"","field":{
      disabled:
        _vm.field.name === 'hrpac_selection_stage_id_c_advanced' &&
        !_vm.form['hrpac_vacancy_id_c_advanced'],
      name: _vm.field.name,
      placeholder: '',
      multiple: _vm.field.type === 'dynamicMultienum',
      type: _vm.field.type === 'dynamicMultienum' ? 'relate' : 'enum'
    },"arrow-multiselect-focus":true,"reserve-keyword":_vm.field.type === 'dynamicMultienum' ? true : false,"visible-option-btn":false,"visibleLoadMoreBtn":_vm.loadMoreNum == 50,"create-btn-text":"Добавить","popper-class":"filter-dropdown"},on:{"load-more":str => _vm.setNewOptions(str, _vm.field.name, _vm.field.paginationUrl),"filter-option":str => _vm.filterOptions(str, _vm.field.name, _vm.field.paginationUrl),"set-value":(name, val) => {
        _vm.setValue(_vm.field.name, val);
      }}}):(_vm.field.type === 'multienum')?_c('Dropdown',{attrs:{"model":_vm.form[_vm.field.name] || [],"field":{
      name: _vm.field.name,
      placeholder: '',
      type: 'multienum',
      multiple: true,
      filterable: true
    },"options":_vm.field.options,"popper-class":"filter-dropdown"},on:{"set-value":(name, val) => {
        _vm.setValue(_vm.field.name, val);
      }}}):(_vm.field.type == 'multiLevelEnum')?_c('MultiLevelSelect',{key:_vm.update,attrs:{"field":_vm.field,"model":_vm.form[_vm.field.name] || '',"label":_vm.multiLevelLabel,"options":_vm.paginOptions[_vm.field.name],"module":_vm.module},on:{"set-value":(name, val) => _vm.setValue(_vm.field.name, val, _vm.field.type),"change-option":_vm.selectOption,"load-more":str => _vm.setNewOptions(str, _vm.field.name, _vm.field.paginationUrl),"filter-option":str => _vm.filterOptions(str, _vm.field.name, _vm.field.paginationUrl),"set-label":lbl => _vm.changeLabel(lbl)}}):(_vm.field.type == 'multiLevelEnumLazy')?_c('MultiLevelSelectLazy',{key:_vm.update,attrs:{"field":_vm.field,"model":_vm.form[_vm.field.name] || '',"label":_vm.multiLevelLabel,"loading":_vm.loading,"options":_vm.paginOptions[_vm.field.name],"visibleLoadMoreBtn":_vm.field['multi-level-schema']?.limit &&
      _vm.loadMoreNum == _vm.field['multi-level-schema']?.limit,"module":_vm.module,"form":_vm.form,"clearable":true,"lazy-loaded":_vm.lazyLoaded},on:{"set-value":(name, val) => _vm.setValue(_vm.field.name, val, _vm.field.type),"change-option":_vm.selectOption,"load-more":(str, method, url) => _vm.setNewOptions(str, _vm.field.name, url, true),"filter-option":(str, method, url) => _vm.filterOptions(str, _vm.field.name, url),"set-label":lbl => _vm.changeLabel(lbl),"reset-lazy-loaded":function($event){_vm.lazyLoaded = false}}}):(_vm.field.type === 'date' || _vm.field.type === 'datetime')?_c('DatePicker',{attrs:{"model":_vm.form[_vm.field.name] || '',"field":{
      name: _vm.field.name,
      type: 'date'
    },"datepicker":_vm.datepicker,"options":_vm.pickerOptions},on:{"set-value":(name, val) => _vm.setValue(_vm.field.name, val, 'else')}}):_c('Input',{attrs:{"field":{
      htmlType: _vm.fieldType(_vm.field.type),
      name: _vm.field.name,
      maxlength: '255',
      type: _vm.field.type
    },"model":_vm.formatHtml(_vm.form[_vm.field.name] || '')},on:{"set-value":(name, val) => {
        _vm.setValue(_vm.field.name, val, 'else');
      }}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }